import React from 'react';
import '../assets/css/document-body.css';
import { parseDocumentBody, renderPlaceholders } from '../utils/documentBody';
import { removeAllSpacesInString } from '../utils/regex';

// 書面本文（プレーンテキスト）を表示用に整形する。
// 管理者が入力した文字列はHTMLとして解釈せず、テキストのまま描画する。
function DocumentBody({ body, values, className }) {
  // 書面に差し込む氏名は姓名間のスペースを詰める（写真使用許可書の従来表記に合わせる）。
  // 実画面・管理者プレビューのどちらもここを通すことで表示を一致させる。
  const resolved = values && values.name !== undefined
    ? { ...values, name: removeAllSpacesInString(values.name) }
    : values;
  const blocks = parseDocumentBody(renderPlaceholders(body, resolved));

  return (
    <div className={className ? `document-body ${className}` : 'document-body'}>
      {blocks.map((block, index) => {
        if (block.type === 'heading') {
          return (
            <h2 key={index} className="text-center text-bold">
              {block.text}
            </h2>
          );
        }
        if (block.type === 'list') {
          return <ul key={index}>{renderItems(block.items)}</ul>;
        }
        return <p key={index}>{block.text}</p>;
      })}
    </div>
  );
}

// レベル1の項目は直前の項目にぶら下げて入れ子表示する
function renderItems(items) {
  const nodes = [];
  let index = 0;

  while (index < items.length) {
    const item = items[index];
    const children = [];
    let next = index + 1;
    while (next < items.length && items[next].level > item.level) {
      children.push(items[next]);
      next += 1;
    }

    nodes.push(
      <li key={index}>
        {item.text}
        {children.length > 0 && <ul>{renderItems(children)}</ul>}
      </li>
    );
    index = next;
  }

  return nodes;
}

export default DocumentBody;
